<template>
  <div class="page-template">
    <div style="display: flex">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="save" type="primary" plain>保存</el-button>
      <div class="page-title" style="text-align: center;margin-bottom: 10px;flex:1">新增直播间</div>
    </div>
    <div style="padding: 10px 20px;">
      <el-row>
      <el-form :model="form" :rules="rules" ref="form" class="setting-form" label-width="110px" :inline-message="true">
        <el-col :span="24">
          <el-form-item prop="type" label="直播类型">
            <el-radio-group
              v-model="form.type"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="name" label="直播间名称">
            <el-input class="inputStyle" v-model="form.name" :min="4" :max="34"></el-input>
          </el-form-item>
          <p class="tips" style="padding-left:100px;margin-top:-6px">最短3个汉字，最长17个汉字，1个汉字相当于2个字符</p>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="timeList" label="开播时间">
<!--            <el-date-picker-->
<!--              @change="changeDate"-->
<!--              class="time"-->
<!--              :picker-options="pickerOptions"-->
<!--              value-format="yyyy-mm-dd hh:mm:ss"-->
<!--              v-model="form.timeList"-->
<!--              type="datetimerange"-->
<!--              range-separator="至"-->
<!--              start-placeholder="开始时间"-->
<!--              end-placeholder="结束时间"-->
<!--              :default-time="defaultTime"-->
<!--            ></el-date-picker>-->
            <el-date-picker
              @change="changeDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="form.startTime"
              type="datetime"
              placeholder="选择开始时间"
              :default-time="defaultTimeStart"
              :picker-options="pickerOptionStart">
            </el-date-picker>
            至
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="form.endTime"
              type="datetime"
              placeholder="选择结束时间"
              :default-time="defaultTimeEnd"
              :picker-options="pickerOptionEnd">
            </el-date-picker>
          </el-form-item>
          <p class="tips" style="padding-left: 100px;margin-top:-6px">开播时间需要在当前时间的20分钟后,并且开始时间不能在6个月后；开播时间和结束时间间隔不得短于30分钟，不得超过24小时</p>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="anchorName" label="主播昵称">
            <el-input class="inputStyle" v-model="form.anchorName"></el-input>
          </el-form-item>
          <p class="tips" style="padding-left:100px;margin-top:-6px">最短2个汉字，最长15个汉字，1个汉字相当于2个字符</p>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="anchorWechat" label="主播微信号">
<!--              <el-link type="primary" @click="selectMember">从直播成员中选择</el-link>-->
              <el-select v-model="form.anchorWechat" placeholder="请从直播成员中选择" :disabled="isDisabled" @change="selectStore" class="select-style">
                <el-option
                  v-for="(item,index) in anchorList"
                  :key="index"
                  :label="item.name"
                  :value="item.wechantCode">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.wechantCode }}</span>
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="subAnchor" label="主播副号">
            <el-input class="inputStyle" v-model="form.subAnchor"></el-input>
            <p class="tips">直播时，主播副号能在主播端进行推送商品，抽奖等操作。仅从主播端小程序进入时，副号身份才生效。若从观众端进入，副号身份不生效。</p>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shareImg" label="分享卡片封面">
<!--            <div style="display: flex">-->
<!--              <div style="width: 100px;text-align: right;padding-right:9px;">-->
<!--                <span style="color:red">*</span>-->
<!--                <span style="">分享卡片封面</span>-->
<!--              </div>-->
              <div class="file-upload">
                <div class="img-item" v-if="form.shareImgUrl">
                  <img class="image-box" :src="form.shareImgUrl" @click="previewImg(0)"/>
                  <i class="el-icon-error icon-delete" @click="fileDelete(0)"></i>
                </div>
                <div v-else>
                  <i class="el-icon-plus" @click="changeUpload(0)" ></i>
                </div>
              </div>
<!--            </div>-->
<!--            <el-upload-->
<!--              :action="url"-->
<!--              list-type="picture-card"-->
<!--              :on-preview="previewImg"-->
<!--              :before-upload="beforeUpload"-->
<!--              :limit="1"-->
<!--              :file-list="imagelist"-->
<!--              :on-exceed="exceed"-->
<!--              :on-change="changeUpload"-->
<!--              :on-remove="removeImg">-->
<!--              <i class="el-icon-plus"></i>-->
<!--            </el-upload>-->

              <p class="tips">建议尺寸：800像素*640像素，图片大小不得超过1M。</p>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="feedsImg" label="直播卡片封面" label-width="120px">
            <div class="file-upload">
              <div class="img-item" v-if="form.feedsImgUrl">
                <div class="image-box" :style="{backgroundImage:'url('+form.feedsImgUrl+')'}" @click="previewImg(1)"></div>
                <i class="el-icon-error icon-delete" @click="fileDelete(1)"></i>
              </div>
              <div v-else>
                <i class="el-icon-plus" @click="changeUpload(1)" ></i>
              </div>
            </div>
            <p class="tips">建议尺寸：800像素*800像素,图片大小不超过 300KB。</p>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="coverImg" label="直播间背景墙" label-width="120px">
            <div class="file-upload">
              <div class="img-item" v-if="form.coverImgUrl">
                <div class="image-box" :style="{backgroundImage:'url('+form.coverImgUrl+')'}" @click="previewImg(2)"></div>
                <i class="el-icon-error icon-delete" @click="fileDelete(2)"></i>
              </div>
              <div v-else>
                <i class="el-icon-plus" @click="changeUpload(2)" ></i>
              </div>
            </div>
            <p class="tips">建议尺寸：600像素*1300像素，图片大小不得超过3M。</p>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="closeLike" label="是否关闭点赞">
            <el-switch
              v-model="form.closeLike"
              :active-value="true"
              :inactive-value="false"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="closeGoods" label="是否关闭货架">
            <el-switch
              v-model="form.closeGoods"
              :active-value="true"
              :inactive-value="false"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="closeComment" label="是否关闭评论">
            <el-switch
              v-model="form.closeComment"
              :active-value="true"
              :inactive-value="false"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="closeReplay" label="是否关闭回放">
            <el-switch
              v-model="form.closeReplay"
              :active-value="true"
              :inactive-value="false"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="closeShare" label="是否关闭分享">
            <el-switch
              v-model="form.closeShare"
              :active-value="true"
              :inactive-value="false"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="closeKf" label="是否关闭客服">
            <el-switch
              v-model="form.closeKf"
              :active-value="true"
              :inactive-value="false"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="remarks" label="备注">
            <el-input class="inputStyle" v-model="form.remarks"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
        </el-row>
    </div>
    <el-dialog title="图片预览" :visible.sync="dialogVisible">
      <div style=";text-align: center">
        <img :src="imageUrl" alt="" style="width: 60%">
      </div>
    </el-dialog>
<!--    <el-dialog title='成员信息' :visible.sync="dialogShow" @close="closeDialog" width="800px" center :close-on-click-modal="false">-->
<!--      <el-input-->
<!--        class="search-input"-->
<!--        v-model.trim="searchForm.name"-->
<!--        placeholder="输入微信号或昵称选择成员"-->
<!--        @change="searchValue"-->
<!--        clearable-->
<!--      >-->
<!--        <el-button type="primary" slot="append" @click="searchValue">查询</el-button>-->
<!--      </el-input>-->
<!--      <span class="tips">选择未绑定直播身份的成员，将自动为其绑定主播身份</span>-->
<!--      <el-row class="info-main">-->
<!--          <div :class="activeClass === index?'info-item info-item-active':'info-item'" v-for="(item, index) in memberList" :key="index" @click="handdleMember(item,index)">-->
<!--            <img :src="item.src" class="image">-->
<!--            <div class="info-item-right">-->
<!--              <p style="font-weight: 700">{{item.name}}</p>-->
<!--              <p class="tips">{{item.code}}</p>-->
<!--              <el-tag type="info" size="mini">{{item.role}}</el-tag>-->
<!--            </div>-->
<!--          </div>-->
<!--      </el-row>-->
<!--    </el-dialog>-->
  </div>
</template>
<script>
  import api from '@/config/api';
  import fileTemplate from "@/components/controls/fileTemplate";

  export default {
  components: {
    fileTemplate,
  },
  data() {
    function setTime(val){
      let now = new Date(Date.parse(new Date)+parseInt(val * 60 * 1000))
      let hours = now.getHours()<10?'0'+now.getHours():now.getHours()//小时
      let minutes =now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes()//分
      let seconds = now.getSeconds()<10?'0'+now.getSeconds():now.getSeconds()//秒
      return hours+':'+minutes+':'+seconds
    }
    let startTime = setTime(20)
    let endTime = setTime(50)
    return {
      defaultTimeStart:startTime,//默认开始时间
      defaultTimeEnd:endTime,//默认结束时间
      pickerOptionStart: {
        selectableRange: startTime+' - 23:59:59',
        disabledDate: time => {
          //设置当前时间后的时间不可选 8.64e7一天的时间戳
          return (time.getTime() > new Date().getTime()+ 180*8.64e7||time.getTime()<new Date().getTime()- 1*8.64e7)
        }
      },
      pickerOptionEnd: {
        selectableRange: endTime+' - 23:59:59',
        disabledDate: time => {
          //设置当前时间后的时间不可选 8.64e7一天的时间戳
          return (time.getTime() > new Date().getTime()+ 180*8.64e7||time.getTime()<new Date().getTime()- 1*8.64e7)
        }
      },
      imageUrl:'',
      dialogVisible:false,
      anchorList:[],
      activeClass:null,
      memberList:[],
      searchForm:{
        name:'',
      },
      url:'',
      dialogShow:false,
      expandEffectList:[
        {name:'回放',id:1},
        {name:'官方收录',id:2},
      ],
      liveEffectList:[
        {name:'评论',id:1},
        {name:'商品货架',id:2},
        {name:'分享',id:3},
        {name:'点赞',id:4},
      ],
      typeList:[
        {label:'手机直播',id:0},
        {label:'推流设备直播',id:1},
      ],
      isDisabled:false,
      form:{
        type:0,//直播间类型 【1: 推流，0：手机直播】
        name:'',//直播间名称
        timeList:'',
        startTime:'',
        endTime:'',
        coverImg:'',//背景图
        coverImgUrl:'',
        shareImg:'',//分享图
        shareImgUrl:'',
        feedsImg:'',//封面图
        feedsImgUrl:'',
        anchorName:'',//主播昵称
        anchorWechat:'',//主播微信号
        subAnchor:'',//主播副号微信号
        createrWechat:'',//创建者微信号
        isFeedsPublic:'',//是否开启官方收录 【1: 开启，0：关闭】，默认开启
        closeLike:false,//是否关闭点赞 【0：开启，1：关闭】（若关闭，观众端将隐藏点赞按钮，直播开始后不允许开启）',
        closeGoods:false,//是否关闭货架 【0：开启，1：关闭】（若关闭，观众端将隐藏商品货架，直播开始后不允许开启）',
        closeComment:false,//是否关闭评论 【0：开启，1：关闭】若关闭，观众端将隐藏评论入口，直播开始后不允许开启）',
        closeReplay:false,//是否关闭回放 【0：开启，1：关闭】默认关闭回放（直播开始后允许开启）',
        closeShare:false,//是否关闭分享 【0：开启，1：关闭】默认开启分享（直播开始后不允许修改）',
        closeKf:false,//是否关闭客服 【0：开启，1：关闭】默认关闭客服（直播开始后允许开启）',
        remarks:'',//备注
        relateType:this.$utils.getSysUser().storeId?20:10,//10 商户 20门店
        // liveEffect:[],
        // expandEffect:[],
      },
      rules:{
        type:[{required:true,message:'请选择直播类型',trigger:'change'}],
        name:[{required:true,pattern: "^.{3,17}$", message: '请输入正确名称', trigger: 'blur'}],
        anchorName:[{required:true,pattern: "^.{2,15}$", message: '请输入正确的昵称', trigger: 'blur'}],
        // anchorName:[{required:true,message:'请输入主播昵称',trigger:'change'}],
        startTime:[{required:true,message:'请选择开始时间',trigger:'change'}],
        endTime:[{required:true,message:'请选择结束时间',trigger:'change'}],
        anchorWechat:[{required:true,message:'请输入主播微信号',trigger:'change'}],
        shareImg:[{required:true,message:'请上传图片',trigger:'change'}],
        feedsImg:[{required:true,message:'请上传图片',trigger:'change'}],
        coverImg:[{required:true,message:'请上传图片',trigger:'change'}],
      },
      title: '',
      dialogVisibility: false,
      showImg:false,
    };
  },
  computed:{

  },
  watch: {
    'form.shareImgUrl': (val, oldVal)=> {
      // this.form.shareImgUrl = val
    },
    'form.feedsImgUrl': (val, oldVal)=> {},
    'form.coverImgUrl': (val, oldVal)=> {},
  },
  created() {
    this.getMemberList()
    if(this.$route.query.id){
      this.getDetail()
    }
  },
  mounted() {
  },
  methods: {
    // 编辑详情
    getDetail(){
      this.$axios.fetchGet('/api/eros/mall/mallLiveRoom/roomId?id='+this.$route.query.id).then(res=>{
        if(res.code == 200){
          if(res.data){
            if(res.data.type == true){
              res.data.type = 1
            }else{
              res.data.type = 0
            }
            this.form = res.data
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      })
    },
    // 文件数量限制
    exceed() {
      this.$message.warning(`只允许上传1个文件`);
    },
    // 判断文件类型
    isExcellType(ext) {
      return ['png','jpg','jpeg','gif'].indexOf(ext.toLowerCase()) !== -1;
    },
    changeUpload(type) {
      this.$utils.uploadFile((file) => {
        let formData = new FormData();
        formData.append('multipartFile', file);
        let index= file.name.lastIndexOf(".");
        let ext = file.name.substr(index+1);
        if(!this.isExcellType(ext)){
          this.$message.warning('PNG,JPEG,JPG,GIF格式!')
        }
        else if(file.size > 1024 * 1024 * 10){
          this.$message.warning('上传文件大小不能超过 10MB!')
        }else{
          this.$axios.fetchPostInUpload('/api/eros/mall/mallLiveRoom/media/upload?fileType=image&merchantId='+this.$utils.getSysUser().merchantId,formData).then((res)=>{
            if(res.code == 200){
              if(res.data){
                if(type == 0){
                  this.form.shareImg = res.data.mediaId
                  this.form.shareImgUrl = res.data.url
                }else if(type == 1){
                  this.form.feedsImg = res.data.mediaId
                  this.form.feedsImgUrl = res.data.url
                }else{
                  this.form.coverImg = res.data.mediaId
                  this.form.coverImgUrl = res.data.url
                }
                this.$notify({
                  type: "success",
                  title: '上传操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message.success('上传成功')
              }
            }else{
              this.$message.error(res.errorMsg)
            }

          })
        }
      })
    },
    // 上传之前的判断
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.warning('上传图片只能是 jpeg/jpg/png 格式!');
      }
      if (!isLt1M) {
        this.$message.warning('上传图片大小不能超过 1MB!');
      }
      return isJPG && isLt1M;
    },
    // 删除图片
    fileDelete(type) {
      if(type == 0){
        this.form.shareImg = ''
        this.form.shareImgUrl = ''
      }else if(type == 1){
        this.form.feedsImg = ''
        this.form.feedsImgUrl = ''
      }else{
        this.form.coverImg = ''
        this.form.coverImgUrl = ''
      }
    },
    // 预览图片
    previewImg(type){
      this.imageUrl = ''
      if(type == 0){
        this.imageUrl = this.form.shareImgUrl
      }else if(type == 1){
        this.imageUrl = this.form.feedsImgUrl
      }else{
        this.imageUrl = this.form.coverImgUrl
      }
      this.dialogVisible = true;
    },
    // 选择时间
    changeDate(val){
    },
    // 获取成员
    getMemberList() {
      this.$axios.fetchPost(api.mall.mallLiveRole+'/list',{type:2}).then(res=>{
        if(res.code === 200){
          this.anchorList = res.data
        }else{
          this.$message.error(res.errorMsg || '获取成员失败')
        }
      })
    },
    // 点击选择成员
    selectStore(val){},
    selectMember(){
      this.dialogShow = true
    },
    // 搜索成员
    searchValue(){},
    closeDialog(){
      this.activeClass = null
    },
    // 选中成员
    handdleMember(item,index){
      this.activeClass = index
    },
    save() {
      this.$refs.form.validate(valid=>{
        if(valid){
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)',
          });
          if(this.$route.query.id){//编辑
            this.$axios.fetchPut('/api/eros/mall/mallLiveRoom', this.form).then(data => {
              if (data.code === 200) {
                this.$notify({
                  type: "success",
                  title: '提交操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({type: 'success', message: '提交成功'});
                this.beBack()
              } else {
                this.$message({type: 'error', message: data.errorMsg});
              }
            }).catch((err) => {
              this.$notify({
                type: "error",
                title: '提交操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '保存失败', type: 'error'});
            }).finally(() => {
              loading.close()
            })
          }else{//新增
            this.$axios.fetchPost('/api/eros/mall/mallLiveRoom', this.form).then(data => {
              if (data.code === 200) {
                this.$notify({
                  type: "success",
                  title: '提交操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({type: 'success', message: '提交成功'});
                this.beBack()
              } else {
                this.$message({type: 'error', message: data.errorMsg});
              }
            }).catch((err) => {
              this.$notify({
                type: "error",
                title: '提交操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '保存失败', type: 'error'});
            }).finally(() => {
              loading.close()
            })

          }
          }else{
            return false
          }
      })
    },
    //返回按钮事件
    beBack() {
      this.$router.go(-1);
    },
  }
};
</script>
<style scoped>
/*.setting-form{*/
/*  height:600px;*/
/*}*/
.foot{
  text-align: center;
}
.tips{
  color:#999;
  font-size: 12px;
  line-height: 20px;
}
.select-number{
  width:80px;
}
>>> .el-form-item{
  min-height: unset;
  padding-bottom:5px;
}
>>> .el-form-item__content, .el-form-item__label{
  line-height: 30px;
}
.search-input{
  width:280px;
  line-height: normal;
}
>>>.el-input-group__prepend{
  background-color:#458cff;
  color:#fff;
  border-color:#458cff;
  font-weight: 700;
  /*padding:0 30px;*/
}
/*成员列表*/
.info-main{
  padding:10px 0;
  display: flex;
  /*justify-content: space-between;*/
}
.info-item{
  display: flex;
  border:1px solid #e0dddd;
  border-radius: 5px;
  padding:10px;
  margin-right: 20px;
  /*height:100px;*/
  width:30%;
  cursor: pointer;
}
.info-item-active{
  border-color: #01AAED;
}
.info-item-right{
  padding-left:10px;
  flex:1;
}
.image {
  width: 70px;
  height:70px;
  display: block;
  border-radius: 5px;
}
.inputStyle{
  width:300px;
}
.select-style,.select-style >>> .el-input{
  width:300px;
}
>>> .el-form-item__error{
  padding-top:0;
}
>>> .el-form-item__content, .el-form-item__label{
  line-height: 30px;
}
/*时间日期选择器*/
.time{
  width:unset;
}
>>> .el-date-editor .el-range-separator{
  line-height: 24px;
}
>>> .el-date-editor .el-range__icon{
  line-height: 24px;
}
>>> .el-date-editor .el-range__close-icon{
  line-height: 24px;
}
/*上传样式*/
.file-upload{
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #C0C4CC;
  border-radius: 5px;
  color: #C0C4CC;
  background-size: 100% 100%;
  position: relative;
  margin-right: 10px;
  font-size: 40px;
}
.file-upload .img-item{
  border:none;
}
.file-upload .img-item .icon-delete {
  font-size: 20px;
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
  color:red;
}
.file-upload .img-item .image-box {
  width: 78px;
  height: 78px;
  border-radius: 5px;
  background-size:100% 100%;
}
</style>
<style>
.el-date-range-picker__editor{
  min-width:125px !important;
  max-width:125px !important;
}
</style>




// WEBPACK FOOTER //
// src/page/system/applet/live/liveAdd.vue